import { apiProducts } from "./api";

export const saleInProgressUpdateStatus = (params) => {
  return apiProducts.patch("/api/sale-in-progress/update-status", params);
};

export const saleInProgressUpdateStatusPosition = (params) => {
  return apiProducts.patch("/api/sale-in-progress/update-status/position", params);
};
